export function getRelativeDate(momentObject) {
  return momentObject.calendar(undefined, {
    sameDay: '[Today]',
    lastDay: '[Yesterday]',
    lastWeek: 'MMMM D, YYYY',
    sameElse: 'MMMM D, YYYY'
  });
}
